export const sources={};export const img={src:"__VITE_ASSET__K0d7Xv_kmrg9pjrMnixeoA__",w:640,h:640};export default{sources:sources,img:img};